import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'Store/Store';
import { useRecordingCalls } from 'Utils/hooks/useRecordingCalls';

export const RecordingsContextProvider = ({ children }) => {
    const { userData } = useStore();
    const [recordings, setRecordings] = useState([]);
    const [plannedRecordings, setPlannedRecordings] = useState([]);
    const [recordingsTimeIptv, setRecordingsTimeIptv] = useState({});
    const [recordingsTimeGo, setRecordingsTimeGo] = useState({});
    const [recordingIds, setRecordingIds] = useState([]);
    const { fetchRecordings } = useRecordingCalls();

    const updateRecordings = async () => {
        // If user is not logged in, no recordings data can be available
        if (!userData) return [];

        const { items, iptv, go, plannedItems, ids } = await fetchRecordings();

        setRecordings(items);
        setPlannedRecordings(plannedItems);
        setRecordingsTimeIptv(iptv);
        setRecordingsTimeGo(go);
        setRecordingIds(ids);

        return items;
    };

    useEffect(() => {
        if (userData) {
            updateRecordings();
        }
    }, [userData]);

    return (
        <RecordingsContext.Provider
            value={{
                recordings,
                plannedRecordings,
                updateRecordings,
                recordingsTimeIptv,
                recordingsTimeGo,
                recordingIds
            }}
        >
            {children}
        </RecordingsContext.Provider>
    );
};

RecordingsContextProvider.defaultProps = {
    children: []
};

RecordingsContextProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const RecordingsContext = createContext({
    recordings: [],
    plannedRecordings: [],
    updateRecordings: () => {},
    // eslint-disable-next-line no-new-wrappers
    recordingsTimeIptv: new Number(),
    // eslint-disable-next-line no-new-wrappers
    recordingsTimeGo: new Number(),
    recordingIds: []
});

export const useRecordings = () => useContext(RecordingsContext);

export const withRecordings = (Component) => (props) => (
    <RecordingsContext.Consumer>
        {(context) => <Component {...props} {...context} />}
    </RecordingsContext.Consumer>
);
